import React, { useContext } from "react";
import "./style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Switch } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Reviews from "./pages/Reviews";
import BusinessReview from "./pages/BusinessReview";
import Profile from "./pages/Profile";
import UpgradePlan from "./pages/UpgradePlan";
import Error404 from "./pages/404";
import MyListing from "./pages/MyListing";
// import Listing from "./pages/Listing";
import SearchListing from "./pages/SearchListing";
import AddListing from "./pages/AddListing";
import Packages from "./pages/Packages";
import EditListing from "./pages/EditListing";
import Register from "./pages/Register";
import ResetPassword from "./pages/ResetPassword";
import Login from "./pages/Login";
import ListingDetails from "./pages/ListingDetails";
import Support from "./pages/Support";
import DashboardHome from "./pages/Dashboard";
import RateUs from "./pages/RateUs";
import Privacy from "./pages/Privacy";
import CookiesPolicy from "./pages/CookiesPolicy";
import TermsConditions from "./pages/TermsConditions";
import ListingAdmin from "./pages/ListingsAdmin";
import AdminListingDetails from "./pages/AdminListingDetails";
import Advert from "./pages/AdvertAdmin";
import DashboardCategories from "./pages/DashboardCategories";
import AdminDashboard from "./pages/DashboadAdmin";
import RegisterThanks from "./pages/RegisterThanks";
import Contact from "./pages/Contact";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { UserContext } from "./components/UserContext";
import PrivateRoute from "./components/authRoute/privateRoute";
import AdminRoute from "./components/authRoute/adminRoute";
import PublicRoute from "./components/authRoute/publicRoute";
function App(props) {
  const user = useContext(UserContext);

  return (
    <div className="App">
      <Switch>
        <PublicRoute
          user={user.user}
          restricted={false}
          exact
          component={Home}
          path="/"
        />
        <PublicRoute
          user={user.user}
          restricted={false}
          exact
          component={About}
          path="/about"
        />
        <PublicRoute
          user={user.user}
          restricted={true}
          exact
          component={Login}
          path="/login"
        />
        <PublicRoute
          user={user.user}
          restricted={false}
          exact
          component={SearchListing}
          path="/listing"
        />
        <PublicRoute
          user={user.user}
          restricted={false}
          exact
          component={Privacy}
          path="/privacy"
        />
        <PublicRoute
          user={user.user}
          restricted={false}
          exact
          component={CookiesPolicy}
          path="/cookies-policy"
        />
        <PublicRoute
          user={user.user}
          restricted={false}
          exact
          component={TermsConditions}
          path="/terms-conditions"
        />
        <PublicRoute
          user={user.user}
          restricted={false}
          exact
          component={SearchListing}
          path="/listing/service=:service&city=:city"
        />
        <PublicRoute
          user={user.user}
          restricted={false}
          exact
          component={SearchListing}
          path="/listing/service=:service"
        />
        <PublicRoute
          user={user.user}
          restricted={true}
          exact
          component={Register}
          path="/register"
        />
        <PublicRoute
          user={user.user}
          restricted={true}
          exact
          component={ResetPassword}
          path="/reset-password"
        />
        <PublicRoute
          user={user.user}
          restricted={false}
          exact
          component={ListingDetails}
          path="/listing-details/:listing"
        />
        <PublicRoute
          user={user.user}
          restricted={false}
          exact
          component={Support}
          path="/support"
        />
        <PublicRoute
          user={user.user}
          restricted={true}
          exact
          component={RegisterThanks}
          path="/complete-register/name=:name"
        />
        <PublicRoute
          user={user.user}
          restricted={false}
          exact
          component={Contact}
          path="/contact"
        />
        <PrivateRoute
          user={user.user || localStorage.getItem("access_token")}
          exact
          component={AddListing}
          path="/add-listing/:package"
        />
        <PublicRoute
          user={user.user}
          restricted={false}
          exact
          component={Packages}
          path="/packages"
        />
        <AdminRoute
          user={user.user || localStorage.getItem("access_token")}
          exact
          component={ListingAdmin}
          path="/admin/listings"
        />
        <AdminRoute
          user={user.user || localStorage.getItem("access_token")}
          exact
          component={AdminListingDetails}
          path="/admin/listing-details/:listing"
        />
        <AdminRoute
          user={user.user || localStorage.getItem("access_token")}
          exact
          component={Advert}
          path="/admin/advert"
        />
        <PrivateRoute
          user={user.user || localStorage.getItem("access_token")}
          exact
          component={DashboardHome}
          path="/dashboard"
        />
        <PrivateRoute
          user={user.user || localStorage.getItem("access_token")}
          exact
          component={RateUs}
          path="/rate-us"
        />
        <AdminRoute
          user={user.user || localStorage.getItem("access_token")}
          exact
          component={AdminDashboard}
          path="/admin/dashboard"
        />
        <AdminRoute
          user={user.user || localStorage.getItem("access_token")}
          exact
          component={DashboardCategories}
          path="/admin/categories"
        />
        <PrivateRoute
          user={user.user || localStorage.getItem("access_token")}
          exact
          component={MyListing}
          path="/my-listings"
        />
        <PrivateRoute
          user={user.user || localStorage.getItem("access_token")}
          exact
          component={Reviews}
          path="/reviews"
        />
        <PrivateRoute
          user={user.user || localStorage.getItem("access_token")}
          exact
          component={BusinessReview}
          path="/reviews/:business/:ref"
        />
        <PrivateRoute
          user={user.user || localStorage.getItem("access_token")}
          exact
          component={EditListing}
          path="/edit-listing/:business"
        />
        <PrivateRoute
          user={user.user || localStorage.getItem("access_token")}
          exact
          component={Profile}
          path="/profile"
        />
        <PrivateRoute
          user={user.user || localStorage.getItem("access_token")}
          exact
          component={UpgradePlan}
          path="/change-plan"
        />
        <PublicRoute {...props} restricted={false} exact component={Error404} />
      </Switch>
    </div>
  );
}

export default App;
